// Copyright (c) Docugami, Inc. All rights reserved.

import { APPEND_DOCUMENTS, DocumentsState, SET_DOCUMENT_VIEWER_HEIGHT, CanvasSelectionMode, SET_SELECTION_MODE, SET_MODAL_SELECTION_CONTEXT, APPEND_DOCUMENT, ModalSelectionItemType, SET_MODAL_DISPLAY_CONTEXT, SET_SELECTION_MODE_LOCKED, SET_DOCUMENT_PAGE_COUNT, UPDATE_DOCUMENT } from "./types";
import { REMOVE_FROM_CLUSTER, ADD_TO_CLUSTER } from "../clusters/types";
import produce from "immer";

const initialState: DocumentsState = {
    indexed: {},
    allIds: [],
    selectionMode: CanvasSelectionMode.Select,
    documentViewerHeight: 0,
    modalSelectionContext: {
        isActive: false,
        itemType: ModalSelectionItemType.None
    }
};

export function documentsReducer(
    state = initialState,
    action: any
): DocumentsState {
    switch (action.type) {
        case APPEND_DOCUMENT: {
            return {
                ...state,
                indexed: {
                    ...state.indexed,
                    [action.payload.clusterDocument.folderId]: action.payload
                },
                allIds: [...state.allIds, action.payload.clusterDocument.folderId]
            }
        }

        case APPEND_DOCUMENTS: {
            return {
                ...state,
                indexed: { ...state.indexed, ...action.payload.indexed },
                allIds: [...state.allIds, ...action.payload.allIds]
            };
        }

        case UPDATE_DOCUMENT: {
            return {
                ...state,
                indexed: {
                    ...state.indexed,
                    [action.payload.document.folderId]: {
                        ...(state.indexed[action.payload.document.folderId] || {}),
                        clusterDocument: action.payload.document
                    }
                },
                allIds: [...state.allIds.filter(x => x !== action.payload.document.folderId), action.payload.document.folderId]
            }
        }

        case SET_SELECTION_MODE: {
            return {
                ...state,
                selectionMode: action.payload
            }
        }

        case SET_SELECTION_MODE_LOCKED: {
            return {
                ...state,
                selectionModeLocked: action.payload
            }
        }

        case SET_DOCUMENT_VIEWER_HEIGHT: {
            return {
                ...state,
                documentViewerHeight: action.payload
            }
        }

        case REMOVE_FROM_CLUSTER: {
            let indexed = { ...state.indexed };
            for (let folderId of action.payload.folderIds) {
                if (folderId in indexed) {
                    delete indexed[folderId];
                }
            }

            return {
                ...state,
                indexed: indexed
            }
        }

        case ADD_TO_CLUSTER: {
            let indexed = { ...state.indexed };
            for (let folderId of action.payload.folderIds) {
                if (folderId in indexed) {
                    indexed[folderId] = {
                        ...indexed[folderId],
                        clusterDocument: {
                            ...indexed[folderId].clusterDocument,
                            clusterId: action.payload.clusterId
                        }
                    }
                }
            }

            return {
                ...state,
                indexed: indexed
            }
        }

        case SET_MODAL_SELECTION_CONTEXT: {
            return {
                ...state,
                modalSelectionContext: action.payload
            }
        }

        case SET_MODAL_DISPLAY_CONTEXT: {
            return {
                ...state,
                modalSelectionContext: {
                    ...state.modalSelectionContext,
                    displayContext: {
                        ...state.modalSelectionContext.displayContext,
                        ...action.payload
                    }
                }
            }
        }

        case SET_DOCUMENT_PAGE_COUNT: {
            return produce(state, x => {
                const document = x.indexed[action.payload.docId]?.clusterDocument;
                if (!!document) {
                    document.numberOfPages = action.payload.value;
                }
            })
        }

        default:
            return state;
    }
}
